import React from "react";
import { OrdersPageBase } from "../components/orders/OrdersPageBase";
import { BASE_URLS } from "../config/urls";
import { useAuth } from "../context/AuthContext";

export default function OrdersHistoryPage() {
    const { person } = useAuth();

    return (
        <OrdersPageBase
            title="История заявок"
            badgeText="История"
            subtitle="Здесь отображаются завершённые и архивные заявки."
            ordersEndpoint={`${BASE_URLS.api}/orders_history`}
            hints={
                <ul className="schedule-side-list">
                    <li>История хранит все ваши заявки.</li>
                    <li>Если нужно просмотреть поставку — откройте заявку через <strong>«Просмотр»</strong>.</li>
                    <li>Этикетки можно скачать в любой момент (если в заявке есть коробки).</li>
                </ul>
            }
            emptyTitle="История пуста"
            emptySubtitle="Пока нет завершённых заявок — они появятся после первых поставок."
            allowActions={false} // обычно в истории не удаляют/не меняют
            person={person}
        />
    );
}
